import type { GoalPosition } from './PitchPositionIndicator/types'

type NonNullGoalPosition = Exclude<GoalPosition, null>

export type GoalPositionRectConfig = {
  position: NonNullGoalPosition
  x: number
  y: number
}

export const goalPositionRects: GoalPositionRectConfig[] = [
  {
    position: 'upper-left',
    x: 13.5,
    y: 12.5,
  },
  {
    position: 'upper-middle',
    x: 67.5337,
    y: 12.5,
  },
  {
    position: 'upper-right',
    x: 121.568,
    y: 12.5,
  },
  {
    position: 'bottom-left',
    x: 13.5,
    y: 51.5,
  },
  {
    position: 'bottom-middle',
    x: 67.5337,
    y: 51.5,
  },
  {
    position: 'bottom-right',
    x: 121.568,
    y: 51.5,
  },
]
